<div class="box-modal">
    <div class="modal" [ngClass]="Theme" *ngIf="ViewModal" #modal>
      <div class="wrapper">
        <div class="btn-cerrar" (click)="cerrarModal()" #element>
          <app-icon [Path]="'./assets/img/ico_cerrar_base.svg'"></app-icon>
        </div>
        <div class="head" #element>
          <div class="icono" *ngIf="Icono">
            <app-icon [Path]="IcoSrc"></app-icon>
          </div>
          <app-text Theme="Heading2" [Text]="TituloModal" [RadiusLoading]="10" style="color: #0078c8;"></app-text>
        </div>
        <div class="body" #element>
          <ng-content select="[mensaje-modal]"></ng-content>
        </div>
        <div class="foo" #element>
          <div *ngIf="Foo">
            <ng-content select="[footer-modal]"></ng-content>
          </div>
        </div>
      </div>
    </div>
  </div>